import {
  Box,
  Card,
  Checkbox,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import { AiOutlinePlusCircle } from "react-icons/ai";

import React, { useEffect, useState } from "react";
import moment from "moment";
import "moment/locale/az";
import { useDispatch, useSelector } from "react-redux";
import {
  updateCompanyTuitionFeeAction,
  updateTuitionFeeAction,
} from "../../../../redux/actions/tuitionFeeActions";
import { TUITION_FEE_MODAL_ACTION_TYPE } from "../../../../redux/actions-type";
import Paids from "./components/Paids";
import LoadingBtn from "../../../Loading/components/LoadingBtn/LoadingBtn";
import { useCustomHook } from "../../../GlobalFunctions/globalFunctions";

const TuitionFeeCompanyConfirmModal = () => {
  const { tuitionFeeModalData, tuitionFeeModalLoading } = useSelector(
    (state) => state.tuitionFeeModal,
  );
  const { contractTypesList } = useCustomHook();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);
  const [workerPower, setWorkerPower] = useState();

  const togglePaymentStatus = () => {
    dispatch(
      updateCompanyTuitionFeeAction(tuitionFeeModalData._id, {
        isPaid: !tuitionFeeModalData.isPaid,
      }),
    );
  };

  const confirmInformationData = [
    {
      id: 1,
      title: "Şirkət:",
      value: `${tuitionFeeModalData?.companyName}`,
    },
    {
      id: 2,
      title: "Satış növü:",
      value:
        contractTypesList.find(
          (item) => item.key === tuitionFeeModalData?.contract?.contractType,
        )?.name || "",
    },
    {
      id: 3,
      title: "Müqavilə başlam tarixi:",
      value: tuitionFeeModalData?.contractStartDate
        ? moment(tuitionFeeModalData?.contractStartDate)
            .locale("az")
            .format("DD.MM.YYYY")
        : "" || "",
    },
    {
      id: 4,
      title: "Müqavilə bitmə tarixi:",
      value: tuitionFeeModalData?.contractEndDate
        ? moment(tuitionFeeModalData?.contractEndDate)
            .locale("az")
            .format("DD.MM.YYYY")
        : "" || "",
    },
    {
      id: 5,
      title: "Ödəniş tarixi:",
      value: tuitionFeeModalData?.paymentDate
        ? moment(tuitionFeeModalData?.paymentDate)
            .locale("az")
            .format("DD.MM.YYYY")
        : "" || "",
    },
  ];

  useEffect(() => {
    if (user.role === "worker") {
      const power =
        user.profiles.find((item) => item.profile === "tuitionFee")?.power ||
        null;

      setWorkerPower(power);
    }
  }, [user]);

  return (
    <div style={{ marginTop: "30px" }}>
      {confirmInformationData?.map((data) => (
        <div className="confirm-information-container" key={data.id}>
          <h2>{data.title}</h2>
          <h2>{data.value}</h2>
        </div>
      ))}

      <div style={{ marginTop: "40px" }} className="tution-fee-confirm-modal">
        <h2 style={{ marginBottom: "40px" }}>Ödəniş:</h2>
        <Box sx={{ width: "100%", marginBottom: "40px" }}>
          <Card
            sx={{
              // borderBottom: "0.1px solid ",
              borderRadius: "8px",
              marginBottom: "20px",
              backgroundColor: "var(--neutrals-200)",
              paddingRight: "10px",
            }}
            className="paids-container"
          >
            <Checkbox
              color="primary"
              onChange={togglePaymentStatus}
              checked={tuitionFeeModalData?.isPaid || false}
              sx={{
                ".MuiCheckbox-sizeMedium": {
                  fontSize: "0px",
                },
              }}
              size="large"
              disabled={false}
            />
            <Typography>{tuitionFeeModalData.payment} AZN</Typography>
          </Card>
        </Box>
      </div>
    </div>
  );
};

export default TuitionFeeCompanyConfirmModal;
